import axios from '../../../utils/request';

function GET_MENULIST() {
    return axios.get("/member/MAdminMenu/index" )
}
function ADD_DATA(params) {
    return  axios.get("/member/MAdminMenu/add" )
}
function SUBMIT_ADD(params) {
    return  axios.post("/member/MAdminMenu/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.get("/member/MAdminMenu/edit",{
        params: {
            ...params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/member/MAdminMenu/editPost",{...params} )
}
function CHANG_STATUS (params) {
    return  axios.post("/member/MAdminMenu/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/member/MAdminMenu/delete",{
        params: {
            ids:params
        }
    } )
}
function LIST_ORDER(params) {
    return  axios.post("/member/MAdminMenu/listOrder",{ list_orders:params} )
}
function ADD_AI(params) {
    return  axios.post("/ai/MAdminMenu/aiAt",{ ...params} )
}

export default {
    GET_MENULIST,
    ADD_DATA,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,
    LIST_ORDER,ADD_AI
};